import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { EcdisTarget } from '../types';

export function useEcdisTargets() {
  return useQuery({
    queryKey: queryKeys.transfers.ecdisTargets,
    queryFn: () => apiClient.get<EcdisTarget[]>('/transfers/targets'),
  });
}
